import { apiClient } from "helpers/api_helper"

export const GetAllReturnSalesData = async (data: any) => {
    try {
        const response = await apiClient.get(`/api/v1/ReturnSalesOrder/GetAllReturnSalesOrdersList`, data);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

export const GetReturnSalesProductData = async (id: string) => {
    try {
        const response = await apiClient.get(`/api/v1/ReturnSalesOrder/GetAllReturnSalesOrdersItemListByReturnSalesOrderId?returnSaleOrderId=${id}`);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

export const GenerateReturnSaleInvoice = async (id: string) => {
    try {
        const response = await apiClient.get(`/api/v1/ReturnSalesOrder/GenerateReturnSalesOrderInvoice?returnSaleOrderId=${id}`);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

export const getReturnSalesOrderDeliveryChalan = async (id: string) => {
    try {
        const response = await apiClient.get(`/api/v1/ReturnSalesOrder/GetReturnSalesOrderDeliveryChalan?id=${id}`);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};